import { useDispatch, useSelector } from 'react-redux';

import { useHasPurchasedTestPrep } from 'my-core/hooks';
import { setLocalStorageBannerHidden } from 'my-core/hooks/useDismissableBanner';

import SiteWideBannerPrintBooklet, { BOOKLET_BANNER_KEY } from './SiteWideBannerPrintBooklet';

import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { clearAppStateKey, toggleSiteWideBanner } from 'my-actions/AppStateActions';

export const BANNER_TRANSITION_DURATION = 300;

const classes = {
  banner: ({ constants, palette, transitions, zIndex }) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    height: constants.APPBAR_HEIGHT,
    width: '100%',
    backgroundColor: palette.common.white,
    zIndex: zIndex.appBar,
    transform: 'translateY(-100%)',
    transition: transitions.create('transform', { duration: BANNER_TRANSITION_DURATION }),

    // for oc booklet print to pdf
    '@media print': { display: 'none' },
  }),
  banner_open: {
    transform: 'none',
  },
};

export { BOOKLET_BANNER_KEY };
const BANNER_BY_KEY = {
  [BOOKLET_BANNER_KEY]: SiteWideBannerPrintBooklet,
  // st_patty: StPattyBanner,
  cyber_month: CyberMonthBanner,
};

export default function SiteWideBanner() {
  const dispatch = useDispatch();
  const banner = useSiteWideBanner();

  const BannerComponent = BANNER_BY_KEY[banner?.key];
  const hasBanner = !!BannerComponent;
  const isBannerOpen = !!banner?.isOpen;

  function closeBanner() {
    // if (banner?.key === 'st_patty') setLocalStorageBannerHidden('st_patty', 3600 * 1000);
    if (banner?.key === 'cyber_month') setLocalStorageBannerHidden('cyber_month', 24 * 3600 * 1000);
    dispatch(toggleSiteWideBanner(false));
    setTimeout(() => dispatch(clearAppStateKey('site_wide_banner')), BANNER_TRANSITION_DURATION);
  }

  return (
    <div css={[classes.banner, isBannerOpen && classes.banner_open]}>
      {hasBanner && <BannerComponent {...banner?.props} onClose={closeBanner} />}
    </div>
  );
}

export function useSiteWideBanner() {
  const banner = useSelector(state => state.appState.site_wide_banner);
  const hasPurchasedTestPrep = useHasPurchasedTestPrep();
  return banner?.key === 'cyber_month' && hasPurchasedTestPrep ? null : banner;
}

function CyberMonthBanner({ onClose }) {
  return (
    <div
      css={({ breakpoints, palette, spacing, typography }) => ({
        height: '100%',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: spacing(0, 2),

        backgroundColor: palette.skyblue.main,
        color: palette.skyblue.contrastText,
        '> .bannerCopy': { ...typography.body1, textAlign: 'center', marginRight: 50 },
        '> .closeBtn': { position: 'absolute', right: 0, top: 0, height: '100%', width: 50, fontSize: 20 },
        [breakpoints.down('md')]: {
          padding: spacing(0, 1),
          '> .bannerCopy': { ...typography.body2, textAlign: 'left', marginRight: 40 },
          '> .closeBtn': { width: 40, fontSize: 16 },
        },
        [breakpoints.down('sm')]: { '& .bannerDetail': { display: 'none' } },
      })}
    >
      <Typography className="bannerCopy">
        <strong>Cyber Month Sale!</strong> 20% off everything until Nov 30.
        <span className="bannerDetail"> Tutoring and admissions are 15% off.</span>
      </Typography>
      <ButtonBase className="closeBtn" onClick={onClose}>
        <FontAwesomeIcon icon={faXmark} />
      </ButtonBase>
    </div>
  );
}

// function StPattyBanner({ onClose }) {
//   return (
//     <div
//       css={({ breakpoints, palette, spacing, typography }) => ({
//         height: '100%',

//         textAlign: 'center',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: spacing(0, 2),

//         backgroundColor: palette.green.medium,
//         color: palette.green.contrastText,
//         '> span': {
//           padding: '0 50px',
//           ...typography.subtitle1,
//           [breakpoints.down('md')]: { fontSize: typography.subtitle2.fontSize },
//           [breakpoints.down(500)]: { fontSize: typography.caption.fontSize },
//         },
//         '> .closeBtn': { position: 'absolute', right: 0, top: 0, height: '100%', width: 50, fontSize: 20 },
//       })}
//     >
//       <span>
//         🍀&nbsp;🌈&nbsp;🍀🌈&nbsp;🍀 Uh oh, A Leprechaun turned Wizeprep green! We're working on a fix
//         🍀&nbsp;🌈&nbsp;🍀🌈&nbsp;🍀
//       </span>
//       <ButtonBase className="closeBtn" onClick={onClose}>
//         <FontAwesomeIcon icon={faXmark} />
//       </ButtonBase>
//     </div>
//   );
// }
